export function fetchAccounts(state, { page, sort, filter }) {
  return {
    ...state,
    accounts: {
      ...state.accounts,
      currentPage: page,
      sort: sort || state.accounts.sort,
      filter: filter || state.accounts.filter,
      fetchingErrorMessage: '',
      isFetching: true,
    },
  };
}

export function fetchAccountsSuccess(state, { accounts }) {
  return {
    ...state,
    accounts: {
      ...state.accounts,
      numberOfPages: accounts.numberOfPages,
      count: accounts.count,
      items: accounts.items,
      isFetching: false,
      fetchingErrorMessage: '',
    },
  };
}

export function fetchAccountsFail(state, error) {
  const errorMessage =
    error.message ? error.message : 'Request failed. Open the browser console for details.';
  return {
    ...state,
    accounts: {
      ...state.accounts,
      isFetching: false,
      fetchingErrorMessage: errorMessage,
    },
  };
}

export function openUpdateAccount(state, { account }) {
  return {
    ...state,
    editAccount: {
      account,
      showModal: true,
      addingErrorMessage: '',
    },
  };
}

export function closeUpdateAccount(state) {
  return {
    ...state,
    editAccount: {
      showModal: false,
      addingErrorMessage: '',
    },
  };
}

export function updateAccountSuccess(state, { accountId, updatedData }) {
  const accountIndex = state.accounts.items.findIndex(x => x._id === accountId);
  const account = state.accounts.items.find(x => x._id === accountId);
  if (!account) {
    return state;
  }

  const sortFunc = (p1, p2) =>
  (p1[state.accounts.sort.key] > p2[state.accounts.sort.key] ? 1 : -1)
  * state.accounts.sort.order;

  return {
    ...state,
    accounts: {
      ...state.accounts,
      items: [
        ...state.accounts.items.slice(0, accountIndex),
        {
          ...account,
          ...updatedData,
        },
        ...state.accounts.items.slice(accountIndex + 1),
      ].sort(sortFunc),
    },
  };
}

export function updateAccountFail(state, error) {
  const errorMessage =
    error.message ? error.message : 'Request failed. Open the browser console for details.';

  return {
    ...state,
    editAccount: {
      ...state.editAccount,
      addingErrorMessage: errorMessage,
    },
  };
}

export function updateAccountStatus(state) {
  return {
    ...state,
    accounts: {
      ...state.accounts,
      isFetching: true,
      fetchingErrorMessage: '',
    },
  };
}

export function updateAccountStatusSuccess(state, { accountId, status }) {
  const accountIndex = state.accounts.items.findIndex(x => x._id === accountId);
  const account = state.accounts.items.find(x => x._id === accountId);
  if (!account) {
    return state;
  }

  const sortFunc = (p1, p2) =>
  (p1[state.accounts.sort.key] > p2[state.accounts.sort.key] ? 1 : -1)
  * state.accounts.sort.order;

  return {
    ...state,
    accounts: {
      ...state.accounts,
      items: [
        ...state.accounts.items.slice(0, accountIndex),
        {
          ...account,
          status,
        },
        ...state.accounts.items.slice(accountIndex + 1),
      ].sort(sortFunc),
      isFetching: false,
      fetchingErrorMessage: '',
    },
  };
}

export function updateIsEmailConfirmedSuccess(state, { accountId, isEmailConfirmed }) {
  const accountIndex = state.accounts.items.findIndex(x => x._id === accountId);
  const account = state.accounts.items.find(x => x._id === accountId);
  if (!account) {
    return state;
  }

  return {
    ...state,
    accounts: {
      ...state.accounts,
      items: [
        ...state.accounts.items.slice(0, accountIndex),
        {
          ...account,
          isEmailConfirmed,
        },
        ...state.accounts.items.slice(accountIndex + 1),
      ],
    },
  };
}

export function updateAccountStatusFail(state, error) {
  const errorMessage =
    error.message ? error.message : 'Request failed. Open the browser console for details.';
  return {
    ...state,
    accounts: {
      ...state.accounts,
      isFetching: false,
      fetchingErrorMessage: errorMessage,
    },
  };
}

export function sendEmailConfirmationMessage(state) {
  return {
    ...state,
    account: {
      ...state.account,
      isEmailSending: true,
    },
  };
}

export function sendEmailConfirmationMessageSuccess(state) {
  return {
    ...state,
    account: {
      ...state.account,
      isEmailSending: false,
    },
  };
}

export function sendEmailConfirmationMessageFail(state) {
  return {
    ...state,
    account: {
      ...state.account,
      isEmailSending: false,
    },
  };
}

export function changeAccountStatusCheck(state, accountId) {
  const accountIndex = state.accounts.items.findIndex(x => x._id === accountId);
  const account = state.accounts.items.find(x => x._id === accountId);
  if (!account) {
    return state;
  }

  return {
    ...state,
    accounts: {
      ...state.accounts,
      items: [
        ...state.accounts.items.slice(0, accountIndex),
        {
          ...account,
          statusChecked: !account.statusChecked,
        },
        ...state.accounts.items.slice(accountIndex + 1),
      ],
    },
  };
}

export function changeAllAccountsStatusCheck(state, newValue) {
  return {
    ...state,
    accounts: {
      ...state.accounts,
      items: state.accounts.items.map((account) => ({
        ...account,
        statusChecked: newValue,
      })),
    },
  };
}

export function massUpdateAccountsStatuses(state) {
  return {
    ...state,
    accounts: {
      ...state.accounts,
      isFetching: true,
      fetchingErrorMessage: '',
    },
  };
}

export function massUpdateAccountsStatusesSuccess(state, { accountsIds, status }) {
  const sortFunc = (p1, p2) =>
  (p1[state.accounts.sort.key] > p2[state.accounts.sort.key] ? 1 : -1)
  * state.accounts.sort.order;

  return {
    ...state,
    accounts: {
      ...state.accounts,
      items: state.accounts.items.map((account) => {
        if (!accountsIds.includes(account._id)) {
          return account;
        }

        return {
          ...account,
          statusChecked: false,
          status,
        };
      }).sort(sortFunc),
      isFetching: false,
      fetchingErrorMessage: '',
    },
  };
}

export function massUpdateAccountsStatusesFail(state, error) {
  const errorMessage =
    error.message ? error.message : 'Request failed. Open the browser console for details.';
  return {
    ...state,
    accounts: {
      ...state.accounts,
      isFetching: false,
      fetchingErrorMessage: errorMessage,
    },
  };
}

export function openAccountApps(state, apps) {
  return {
    ...state,
    accounts: {
      ...state.accounts,
      accountApps: {
        showModal: true,
        apps,
      },
    },
  };
}

export function closeAccountApps(state) {
  return {
    ...state,
    accounts: {
      ...state.accounts,
      accountApps: {
        showModal: false,
        apps: [],
      },
    },
  };
}



/** WEBPACK FOOTER **
 ** ./js/core/accounts.js
 **/